import {
    GET_REPORTS_DATA_FOR_DEVICE,
    UPDATE_REPORTS_DATA,
    SERVER_COM_FAILED,
    SET_UPDATE_IN_PROGRESS,
} from '../actions/reportsArchiveActions'
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    API_REQUEST_FAILED_ASK_USER_FOR_RETRY,
} from '../actions/apiActions'

const REPORTS_DATA_URL = 'reports_archive'

const getReportsDataProcess = ({dispatch}) => next => action => {
    next(action)
    
    if (action.type === GET_REPORTS_DATA_FOR_DEVICE) {
        
        const params = {
            data: {
                device: action.payload.id,
                day: action.payload.day,                    
            }
        }
        dispatch(postRequest(REPORTS_DATA_URL, params, UPDATE_REPORTS_DATA, SERVER_COM_FAILED))
    }
}

export const reportsArchiveMiddleware = [
    getReportsDataProcess,
]